import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

import AppContext from "../../../context/AppContext";
import { SIDER_TABS } from "../../../utils/Constants";
import { AppStrings } from "../../../utils/constants/AppStrings";
import { usePamFeature } from "../../../hooks/useFeatureFlag";
import KycCheckpoints from "./KycCheckpoints/KycCheckpoints";
import { usePageTitle } from "../../CommonComponents/Layout/PageTitleContext";

const ConfigurationPage: React.FC = () => {
  usePageTitle(AppStrings.KYC_CONFIGURATION);

  const { setActiveSidebarTab } = useContext(AppContext);
  const location = useLocation();
  // Two gates, both required: SURT is the provider (nothing to configure
  // without it) and surtCheckpoints is the checkpoints feature on top of it.
  // Either off → the page still renders and `KycCheckpoints` shows the
  // disabled notice. It must not redirect: `compliance` resolves to this route
  // in `REDIRECT_PRIORITY`, so a compliance-only admin sent to "/" would be
  // routed straight back here and bounce forever.
  // Only the loading state matters here — the enabled/disabled split is
  // rendered by `KycCheckpoints`.
  const { loading: isSurtLoading } = usePamFeature("surt") as {
    isEnabled: boolean | null;
    loading: boolean;
    error: Error | null;
  };
  const { loading: isCheckpointsLoading } = usePamFeature(
    "surtCheckpoints",
  ) as { isEnabled: boolean | null; loading: boolean; error: Error | null };

  const isFlagLoading = isSurtLoading || isCheckpointsLoading;

  useEffect(() => {
    if (isFlagLoading) return;
    // Matches the sidebar entry: `CONFIGURATIONS_OPTIONS` → `configurations-kyc`.
    setActiveSidebarTab(SIDER_TABS.CONFIGURATIONS, "KYC_CONFIGURATION");
  }, [setActiveSidebarTab, location.pathname, isFlagLoading]);

  if (isFlagLoading) {
    return null;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 24,
          padding: "0 24px 24px 0",
        }}
      >
        <KycCheckpoints />
      </div>
    </>
  );
};

export default ConfigurationPage;
